import type { CountryCode } from "@/config/markets";
import type { ComponentType } from "react";
import { DEFlag } from "./DE";
import { FRFlag } from "./FR";
import { GBFlag } from "./GB";
import { NOFlag } from "./NO";

/** One round 20×20 flag per registered market. */
export const flags: Record<CountryCode, ComponentType> = {
  GB: GBFlag,
  NO: NOFlag,
  DE: DEFlag,
  FR: FRFlag,
};
